//copied from VPC
import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';

import { DetailsTooltipStyles } from '../DetailsTooltipStyles';

export interface NameProps {
  name: string;
}

export function Name(props: NameProps) {
  return <div className={DetailsTooltipStyles.EntityName}>{Messages.CardTooltipTitle({ NAME: props.name })}</div>;
}
